import FilterAttributeMethodsHotelArray from '@ve/components/filters/common/filterMethods/filterAttributeMethodsHotelArray/FilterAttributeMethodsHotelArray';
import facilitiesAttributesHotelData from './facilitiesAttributesHotelData';
import { IFilterFacility } from './index';

export default new FilterAttributeMethodsHotelArray<IFilterFacility>(facilitiesAttributesHotelData, 'facilities').setFilterName('Удобства');